// Copyright (c) 2016 Deere & Company

import SecurityModule from './security-module';
import t from 'tcomb';

const Security = t.struct({
    modules: t.list(SecurityModule, 'SecurityModule'),
    role: t.String,
    userId: t.String
}, {
    name: 'Security',
    strict: true
});

export const getDefaultState = () => new Security({
    modules: [],
    role: '',
    userId: ''
});

export default Security;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/security.js